"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _EmailSubscriptionStore = _interopRequireDefault(require("crm_data/email/EmailSubscriptionStore"));

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _default = {
  stores: [_EmailSubscriptionStore.default],
  deref: function deref(props) {
    var subject = props.subject,
        objectType = props.objectType;

    if (!subject) {
      return _LoadingStatus.LOADING;
    }

    if (objectType !== _ObjectTypes.CONTACT) {
      return _LoadingStatus.EMPTY;
    }

    var email = (0, _ImmutableModel.getProperty)(subject, 'email');

    if (!email) {
      return false;
    }

    var emailSub = _EmailSubscriptionStore.default.get(email);

    if ((0, _LoadingStatus.isLoading)(emailSub)) {
      return _LoadingStatus.LOADING;
    }

    return emailSub && emailSub.get('status') === 'unsubscribed';
  }
};
exports.default = _default;
module.exports = exports.default;